import React from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { blockRetroactiveDates } from "../../../../common/helper";
import { useInterviewContext } from "../../InterviewContext";
import "../../../styles/forms.scss";
import "../../../styles/buttons.scss";
import { useTranslation } from "react-i18next";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";

const AvailabilityPreview = ({ interview }) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const getDateValueValid = (date) => {
    if (date) return new Date(date);
  };

  return (
    <section className="availability">
      <h1>{t("Availability")}</h1>
      <div className="form-check">
        <div
          className={
            interview.availabilityAndConditions.availabilityCode === "UN"
              ? ""
              : "hidden-availability"
          }
        >
          <input
            className="form-check-input"
            type="radio"
            name="availabilityId"
            id="UN"
            checked={
              interview.availabilityAndConditions.availabilityCode === "UN"
            }
            disabled={true}
          />
          <label htmlFor="UN">{t("Unavailable")}</label>
        </div>
        <div
          className={
            interview.availabilityAndConditions.availabilityCode === "IM"
              ? "notice-hidden"
              : "hidden-availability"
          }
        >
          <input
            className="form-check-input"
            type="radio"
            name="availabilityId"
            id="IM"
            checked={
              interview.availabilityAndConditions.availabilityCode === "IM"
            }
            disabled={true}
          />
          <label htmlFor="IM">{t("Immediate")}</label>
        </div>
        <div
          className={
            interview.availabilityAndConditions.availabilityCode === "OH"
              ? "notice-hidden"
              : "hidden-availability"
          }
        >
          <input
            className="form-check-input"
            type="radio"
            name="availabilityId"
            id="OH"
            checked={
              interview.availabilityAndConditions.availabilityCode === "OH"
            }
            disabled={true}
          />
          <label className="form-check" htmlFor="OH">
            {t("Notice")}
          </label>
        </div>
        {interview.availabilityAndConditions.availabilityCode === "UN" && (
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("Reason")}</label>
            </div>
            <input
              disabled={true}
              value={interview.availabilityAndConditions.availabilityReason}
            />
          </div>
        )}
      </div>
      <div
        className={
          interview.availabilityAndConditions.availabilityCode === "OH"
            ? "notice-hidden"
            : "hidden-availability"
        }
      >
        <div className="negotiable">
          <div className="form-group">
            <select
              id="noticeId"
              name="noticeId"
              style={{ width: "290px" }}
              value={interview.availabilityAndConditions.noticeId || "0"}
              title={t("Selecione um item da lista.")}
              required
              disabled={true}
            >
              <option>{interview.availabilityAndConditions.notice}</option>
            </select>
          </div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="negotiable"
              name="negotiable"
              checked={interview.availabilityAndConditions.negotiable}
              disabled={true}
            />
            <label>{t("Negotiable?")}</label>
          </div>
        </div>
      </div>
      <div
        className={
          interview.availabilityAndConditions.availabilityCode === "FD"
            ? "fixed-hidden"
            : "hidden-availability"
        }
      >
        <div className="form-check fixed-date">
          <input
            className="form-check-input"
            type="radio"
            name="availabilityId"
            id="FD"
            checked={
              interview.availabilityAndConditions.availabilityCode === "FD"
            }
            disabled={true}
          />
          <label htmlFor="FD">{t("Fixed date")}</label>
          <div className="training-date">
            <div className="form-group">
              <Datetime
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                isValidDate={blockRetroactiveDates}
                value={getDateValueValid(
                  interview.availabilityAndConditions.fixedDate
                )}
                utc={true}
                closeOnSelect={true}
                inputProps={{
                  placeholder: t("dd-mm-yyyy"),
                  disabled: true,
                  id: "fixedDate"
                }}
                locale={
                  i18n.language === "PT"
                    ? "PT"
                    : i18n.language === "FR"
                    ? "FR"
                    : "EN"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AvailabilityPreview;
